/**
 * WindowDisplayStates — visual display mode of a JxForm window.
 * Purely FE concept — geen BE mirror (client-side only, zie isPinned besluit).
 * Orthogonaal aan isPinned — een window kan Minimized + isPinned tegelijk zijn.
 */
export const WindowDisplayStates = {
    /** Normale, open toestand — geen restore geometry nodig */
    Normal: 'Normal',

    /** Verplaatst naar targetAnchor, body + titlebar verborgen. restoreGeo bewaart pos/size van vóór minimize. */
    Minimized: 'Minimized',

    /** Volledig scherm. restoreGeo bewaart pos/size van vóór maximize. */
    Maximized: 'Maximized',

    /** Blijft op huidige pos, alleen body verborgen — geen restoreGeo nodig, pos/size blijven ongewijzigd. */
    Collapsed: 'Collapsed',
};
